import { useEffect, useState } from "react";
import { fetchProducts } from "../services/products";
import type { Product } from "../types";

/** Cache em memória compartilhado entre Home e Cardápio (evita requisições duplicadas). */
const CACHE_TTL = 60_000;
let cache: { products: Product[]; at: number } | null = null;
let inflight: Promise<Product[]> | null = null;

const loadProducts = () => {
  if (!inflight) {
    inflight = fetchProducts()
      .then((products) => {
        cache = { products, at: Date.now() };
        return products;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

interface ProductsState {
  products: Product[];
  loading: boolean;
  error: boolean;
}

export const useProducts = (): ProductsState => {
  const [state, setState] = useState<ProductsState>(() => ({
    products: cache?.products ?? [],
    loading: cache === null,
    error: false,
  }));

  useEffect(() => {
    if (cache && Date.now() - cache.at < CACHE_TTL) return;

    let active = true;
    loadProducts()
      .then((products) => {
        if (active) setState({ products, loading: false, error: false });
      })
      .catch(() => {
        if (active) setState((prev) => ({ ...prev, loading: false, error: true }));
      });

    return () => {
      active = false;
    };
  }, []);

  return state;
};
